// deviceDetect.js
// Shared device-detection helpers for gating mobile-only features
// (FCM push only makes sense on the device the user actually carries).

export function isMobileDevice() {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || navigator.vendor || window.opera || '';
  return /android|iphone|ipad|ipod|windows phone/i.test(ua);
}

export function isIOSDevice() {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || navigator.vendor || window.opera || '';
  return /iphone|ipad|ipod/i.test(ua);
}

export function isStandalonePWA() {
  if (typeof window === 'undefined') return false;
  return (
    window.navigator.standalone === true ||
    (window.matchMedia && window.matchMedia('(display-mode: standalone)').matches)
  );
}